import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertFeed = ({ alerts, selectedAlert, onSelectAlert, onAcknowledge, onResolve }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'urgent':
        return 'bg-error text-error-foreground';
      case 'high':
        return 'bg-warning text-warning-foreground';
      case 'medium':
        return 'bg-accent text-accent-foreground';
      case 'low':
        return 'bg-muted text-muted-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'unread':
        return 'Bell';
      case 'acknowledged':
        return 'Eye';
      case 'in_progress':
        return 'Clock';
      case 'read':
        return 'CheckCircle';
      default:
        return 'Bell';
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'client_followup':
        return 'Users';
      case 'contract_deadline':
        return 'FileText';
      case 'property_expiration':
        return 'Home';
      case 'property_update':
        return 'RefreshCw';
      case 'system_notification':
        return 'Settings';
      default:
        return 'Bell';
    }
  };

  if (alerts?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border shadow-warm p-8 text-center">
        <Icon name="Inbox" size={48} className="mx-auto mb-4 text-muted-foreground opacity-50" />
        <p className="text-muted-foreground">لا توجد تنبيهات</p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm">
      <div className="p-4 border-b border-border">
        <h3 className="text-base font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="List" size={18} />
          التنبيهات ({alerts?.length})
        </h3>
      </div>
      <div className="divide-y divide-border max-h-[600px] overflow-y-auto">
        {alerts?.map((alert) => (
          <div
            key={alert?.id}
            onClick={() => onSelectAlert(alert)}
            className={`p-4 cursor-pointer transition-all duration-250 hover:bg-muted/50 ${
              selectedAlert?.id === alert?.id ? 'bg-primary/5 border-r-4 border-primary' : ''
            }`}
          >
            <div className="flex items-start justify-between gap-3 mb-2">
              <div className="flex items-start gap-3 flex-1">
                <div className="mt-1">
                  <Icon name={getTypeIcon(alert?.type)} size={20} className="text-primary" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="text-sm font-semibold text-foreground">{alert?.title}</h4>
                    {alert?.escalated && (
                      <span className="px-2 py-0.5 bg-error/10 text-error text-xs rounded-full">
                        تم التصعيد
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-muted-foreground line-clamp-2">{alert?.description}</p>
                  <div className="flex items-center gap-3 mt-2 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="User" size={12} />
                      {alert?.assignedTo}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="Calendar" size={12} />
                      {alert?.createdAt}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-end gap-2">
                <span className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getPriorityColor(alert?.priority)}`}>
                  {alert?.priority === 'urgent' ? 'عاجل' : alert?.priority === 'high' ? 'عالية' : alert?.priority === 'medium' ? 'متوسطة' : 'منخفضة'}
                </span>
                <Icon name={getStatusIcon(alert?.status)} size={16} className="text-muted-foreground" />
              </div>
            </div>
            {alert?.status === 'unread' && (
              <div className="flex items-center gap-2 mt-3">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={(e) => {
                    e?.stopPropagation();
                    onAcknowledge(alert?.id);
                  }}
                >
                  تم الاطلاع
                </Button>
                <Button
                  variant="success"
                  size="sm"
                  onClick={(e) => {
                    e?.stopPropagation();
                    onResolve(alert?.id);
                  }}
                >
                  حل
                </Button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AlertFeed;